import { h, Component } from 'preact';
import cx from 'classnames';

import { BrokerLeaderboard } from '../../../../types/broker-leaderboard.model';

interface BrokerLeaderboardWidgetProps {
  brokers: BrokerLeaderboard[];
}

interface BrokerLeaderboardWidgetState {
  brokers: BrokerLeaderboard[];
  isCollapseVisible?: boolean;
}

export class BrokerLeaderboardWidget extends Component<BrokerLeaderboardWidgetProps, BrokerLeaderboardWidgetState> {
  constructor(props: BrokerLeaderboardWidgetProps) {
    super(props);

    this.setState({
      brokers: props.brokers
    });
  }

  toggleCollapsable = () => {
    this.setState({
      isCollapseVisible: !this.state.isCollapseVisible
    });
  }
  
  render(props: BrokerLeaderboardWidgetProps, state: BrokerLeaderboardWidgetState) {
    return (
      <div className="hi-broker-leaderboard-widget hi-widget-collapsable">
        <div className="row hi-widget-collapsable__toggle-row">
          <div className="col-10">
            <h4 className="hi-broker-leaderboard-widget__name">
              Broker Leaderboard
            </h4>
          </div>
          <div className="col-2 d-md-none">
            <i className={ cx('fas fa-chevron-down', {
                'visible': state.isCollapseVisible
              })}
              onClick={ this.toggleCollapsable }>
            </i>
          </div>
        </div>

        <div className={ cx('hi-widget-collapsable__body', {
          'visible': state.isCollapseVisible
        }) }>
          <div className="row">
            <div className="col-12">
              <p className="hi-broker-leaderboard-widget__desc">
                Top 10 Brokers by Inquiries (last 3 months)
              </p>
            </div>
          </div>

          {/* <div className="row mt-3">
            <div className="col-12">
              <button className="btn hi-broker-leaderboard-widget__cat-toggle active">
                Rental
              </button>
              <button className="btn hi-broker-leaderboard-widget__cat-toggle">
                Sale
              </button>
            </div>
          </div> */}

          <div className="row hi-broker-leaderboard-widget__broker-list mt-4">
            {
              state.brokers.map((broker, index) => {
                return (
                  <div className="col-12 hi-broker-leaderboard-widget__broker mb-4">
                    <div className="hi-broker-leaderboard-widget__broker__img">

                    </div>
                    <div className="hi-broker-leaderboard-widget__broker__details">
                      <p className="hi-broker-leaderboard-widget__broker__name">
                        { broker.partnerBrokerName }
                      </p>
                      <p className="hi-broker-leaderboard-widget__broker__counts"> 
                        <span className="hi-broker-leaderboard-widget__broker__counts__inquiry">
                          { broker.totalInquiriesCount } Inquiries
                        </span>
                        <span className="hi-broker-leaderboard-widget__broker__counts__listings">
                          ({ broker.totalListingCount } Listings)
                        </span>
                      </p>
                    </div>
                    <div className="hi-broker-leaderboard-widget__broker__placement">
                      {/* this should be an image but for now, using css magic */}
                      <div className="hi-broker-leaderboard-widget__broker__placement__badge">
                        { index + 1 }
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>

        

      </div>
    );
  }
}